exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-container .theme--light.v-text-field>.v-input__control>.v-input__slot:before{height:1px;background-color:#ccc}.feedback-container .v-input input{background-color:#fff}.feedback-container textarea{padding:25px 15px 0}.feedback-container p{margin-top:20px;text-align:center;font-size:15px;line-height:1.55}.feedback-container a{text-decoration:underline;color:#00a62a}.feedback-container a:hover{color:#00a62a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10d70e9a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/elements/Feedback.vue
// module id = nwRY
// module chunks = 0 6